(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.initialConfig = initialState ? initialState.map(function(row) {
            return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        }) : null;
        if (initialState) this.grid = initialState.map(function(row) {
            return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        });
        else this.grid = Array(4).fill(null).map(function() {
            return Array(4).fill(0);
        });
        this.score = 0;
        this.status = "idle";
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "processRow",
            value: function processRow(row) {
                var filteredRow = row.filter(function(num) {
                    return num !== 0;
                });
                for(var i = 0; i < filteredRow.length; i++)if (filteredRow[i] === filteredRow[i + 1]) {
                    var newNum = filteredRow[i] *= 2;
                    filteredRow[i + 1] = 0;
                    this.score += newNum;
                }
                filteredRow = filteredRow.filter(function(n) {
                    return n !== 0;
                });
                while(filteredRow.length < 4)filteredRow.push(0);
                return filteredRow;
            }
        },
        {
            key: "transpose",
            value: function transpose() {
                var result = Array(4).fill(null).map(function() {
                    return Array(4).fill(0);
                });
                for(var r = 0; r < this.grid.length; r++)for(var c = 0; c < this.grid[r].length; c++)result[c][r] = this.grid[r][c];
                this.grid = result;
            }
        },
        {
            key: "canMove",
            value: function canMove() {
                var flat = (0, $227c6742e0ff6f82$export$71511d61b312f219)(this.grid).flat();
                if (flat.includes(0)) return true;
                for(var r = 0; r < this.grid.length; r++)for(var c = 0; c < this.grid[r].length; c++){
                    if (c < 3 && this.grid[r][c] === this.grid[r][c + 1]) return true;
                    if (r < 3 && this.grid[r][c] === this.grid[r + 1][c]) return true;
                }
                return false;
            }
        },
        {
            key: "afterMove",
            value: function afterMove(wasChanged) {
                if (this.grid.flat().includes(2048)) this.status = "win";
                if (wasChanged) this.addRandomTile();
                if (this.status === "playing" && !this.canMove()) this.status = "lose";
            }
        },
        {
            key: "processFullGrid",
            value: function processFullGrid() {
                var reverseRows = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                if (this.status !== "playing") return false;
                var wasChanged = false;
                for(var r = 0; r < this.grid.length; r++){
                    var originRow = this.grid[r];
                    var rowToProcess = reverseRows ? (0, $227c6742e0ff6f82$export$71511d61b312f219)(originRow).reverse() : originRow;
                    var row = this.processRow(rowToProcess);
                    if (reverseRows) row.reverse();
                    if (row.join(",") !== originRow.join(",")) wasChanged = true;
                    this.grid[r] = row;
                }
                return wasChanged;
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                var changed = this.processFullGrid(false);
                this.afterMove(changed);
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var changed = this.processFullGrid(true);
                this.afterMove(changed);
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                this.transpose();
                var changed = this.processFullGrid(false);
                this.transpose();
                this.afterMove(changed);
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                this.transpose();
                var changed = this.processFullGrid(true);
                this.transpose();
                this.afterMove(changed);
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.grid;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "addRandomTile",
            value: function addRandomTile() {
                var emptyCells = [];
                for(var r = 0; r < this.grid.length; r++){
                    for(var c = 0; c < this.grid[r].length; c++)if (this.grid[r][c] === 0) emptyCells.push({
                        r: r,
                        c: c
                    });
                }
                if (emptyCells.length === 0) return 0;
                var randomIndex = Math.floor(Math.random() * emptyCells.length);
                var randomCell = emptyCells[randomIndex];
                var value = Math.random() < 0.1 ? 4 : 2;
                this.grid[randomCell.r][randomCell.c] = value;
            }
        },
        {
            key: "start",
            value: function start() {
                this.status = "playing";
                this.addRandomTile();
                this.addRandomTile();
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.score = 0;
                this.status = "idle";
                if (this.initialConfig) this.grid = this.initialConfig.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
                else this.grid = Array(4).fill(null).map(function() {
                    return Array(4).fill(0);
                });
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$gameButton = document.querySelector(".start");
var $197cd56b15c33885$var$field = document.querySelectorAll(".field-cell");
var $197cd56b15c33885$var$score = document.querySelector(".game-score");
var $197cd56b15c33885$var$winMessage = document.querySelector(".message-win");
var $197cd56b15c33885$var$loseMessage = document.querySelector(".message-lose");
var $197cd56b15c33885$var$startMessage = document.querySelector(".message-start");
function $197cd56b15c33885$var$render() {
    $197cd56b15c33885$var$winMessage.classList.add("hidden");
    $197cd56b15c33885$var$loseMessage.classList.add("hidden");
    var grid = $197cd56b15c33885$var$game.getState().flat();
    for(var i = 0; i < grid.length; i++){
        $197cd56b15c33885$var$field[i].textContent = grid[i] === 0 ? "" : grid[i];
        $197cd56b15c33885$var$field[i].className = "field-cell";
        if ($197cd56b15c33885$var$field[i] !== 0) $197cd56b15c33885$var$field[i].classList.add("field-cell--" + grid[i]);
    }
    $197cd56b15c33885$var$score.textContent = $197cd56b15c33885$var$game.getScore();
    switch($197cd56b15c33885$var$game.status){
        case "playing":
            $197cd56b15c33885$var$gameButton.classList.remove("start");
            $197cd56b15c33885$var$gameButton.classList.add("restart");
            $197cd56b15c33885$var$gameButton.textContent = "Restart";
            break;
        case "win":
            $197cd56b15c33885$var$winMessage.classList.remove("hidden");
            break;
        case "lose":
            $197cd56b15c33885$var$loseMessage.classList.remove("hidden");
            break;
    }
}
$197cd56b15c33885$var$gameButton.addEventListener("click", function() {
    $197cd56b15c33885$var$game.restart();
    $197cd56b15c33885$var$game.start();
    $197cd56b15c33885$var$startMessage.classList.add("hidden");
    $197cd56b15c33885$var$render();
});
window.addEventListener("keydown", function(eventR) {
    if ($197cd56b15c33885$var$game.status !== "playing") return;
    switch(eventR.key){
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp();
            eventR.preventDefault();
            $197cd56b15c33885$var$render();
            break;
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown();
            eventR.preventDefault();
            $197cd56b15c33885$var$render();
            break;
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft();
            eventR.preventDefault();
            $197cd56b15c33885$var$render();
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight();
            eventR.preventDefault();
            $197cd56b15c33885$var$render();
            break;
    }
});

})();
//# sourceMappingURL=index.b8db3be1.js.map
